import { useCallback } from 'react';

export const useOpenAtPrice = ({
  blockedRangeForDelayedOrders,
  tickSize,
  store,
}) => {
  const onChange = useCallback(
    (value) => {
      console.log('dbg value', value);
      store.setOpenAtPrice(true);
      if (value > 0) {
        store.setOpenAtPriceOf(value);
      } else {
        store.setOpenAtPriceOf(0);
        store.setOpenAtPrice(false);
      }
    },
    [store]
  );

  const onToggle = useCallback(() => {
    store.toggleOpenAtPrice();
    if (store.openAtPrice) {
      store.setOpenAtPriceOf(blockedRangeForDelayedOrders.max + tickSize);
    } else {
      store.setOpenAtPriceOf(0);
    }
  }, [store.openAtPrice, blockedRangeForDelayedOrders.max, tickSize]);

  return {
    enabled: store.openAtPrice,
    value: store.openAtPriceOf,
    onChange,
    onToggle,
  };
};
